import React from "react";
import PictureTable from "./PictureTable";
import {Button, Icon, Grid, Header, Progress} from "semantic-ui-react";
import '../style.css'


function ListAllPicturesComponent(
    {
        loading,
        progress,
        progressText,
        pictures,
        handleDownload
    }
){
    return (
        <>
            <div className='soundAndPictureList'>
            <Grid centered={true} style={{marginBottom: 10}}>
                {
                    loading ?
                        <Grid.Row>
                            <Progress indicating progress percent={progress} style={{width: 400}}>
                                {progressText}
                            </Progress>
                        </Grid.Row>
                        :
                        <PictureTable
                            pictures={pictures}
                            handleDownload={handleDownload}
                        />
                }

            </Grid>
            </div>
        </>
    )
}

export default ListAllPicturesComponent
